import { createRouter, createWebHistory } from 'vue-router';
import store from '../store/index';

const isValid = () => {
    return store.getters['session/isValid'];
  };

const router = createRouter({
    history: createWebHistory(),
  routes: [
    {
        isPublic: true,
        path: "/",
        component: () => import("../views/Start.vue"),
    
    },
    {
        path: "/Welcome",
        component: () => import("../views/Welcome.vue"), meta: { requiresAuth: true },
    
    },
    {
        path: "/Explanation",
        component: () => import("../views/FirstEvaluation/Explanation.vue"), meta: { requiresAuth: true },
    },
    {
        path: "/Instructions/:evaluation",
        component: () => import("../components/instructions/InstructionComponent.vue"), props:true,  meta: { requiresAuth: true },
    
    },
    {
        path: "/FirstExample",
        component: () => import("../views/FirstEvaluation/Example.vue"), meta: { requiresAuth: true },
    
    },
    {
        path: "/FirstEvaluationTimer",
        component: () => import("../views/FirstEvaluation/EvaluationTimer.vue"), meta: { requiresAuth: true },
    },
    {
        path: "/SecondEvaluation",
        component: () => import("../views/SecondEvaluation/Evaluation.vue"), meta: { requiresAuth: true },
    },
    {
        path: "/Wait/:evaluation",
        component: () => import("../components/wait/WaitComponent.vue"),props:true, meta: { requiresAuth: true },
    },
    {
        path: "/ThirdEvaluation",
        component: () => import("../views/ThirdEvaluation/Evaluation.vue"), meta: { requiresAuth: true },
    },
    {
        path: "/End",
        component: () => import("../views/Final.vue"), meta: { requiresAuth: true },
    },
  ],
});

router.beforeEach((to, from, next) => {
  const currentLang = store.getters['lang/lang'];
  if (!to.query.lang && currentLang) {
    next({
      path: to.path,
      query: { ...to.query, lang: currentLang },
      replace: true,
    });
    return;
  }

  const currentId = new URLSearchParams(window.location.search).get('id');
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (isValid() && currentId ) {
        next();
    } else {
      router.replace('/');
    }
  } else {
    next();
  }
});
  

export default router